<section class="subheader">
    <div class="subheader__content my-3 container px-0">
        <div
            class="subheader__content__row d-flex flex-wrap align-items-center"
        >
            <a
                [routerLink]="'/' | formatUrl"
                class="subheader__content__row__always"
                >{{ 'fe_breadcrumb_home' | translate }}</a
            >
            <div
                class="subheader__content__row__ngfor d-flex align-items-center"
                *ngFor="let breadcrumb of breadcrumbs; let last = last"
            >
                <img
                    [src]="'images/chevron-right.png' | cdn"
                    alt="Right arrow icon"
                    class="subheader__content__row__ngfor__arrow mx-3"
                />
                <a
                    [routerLink]="!last ? (breadcrumb.url | formatUrl) : null"
                    class="subheader__content__row__ngfor__text"
                    >{{ breadcrumb.label | translate }}</a
                >
            </div>
        </div>
    </div>
</section>
